<template>
  <div class="component-upload-image" :class="{ 'is-readonly': readonly }">
    <el-upload :action="uploadImgUrl" :on-success="handleUploadSuccess" :file-list="value"
      :before-upload="handleBeforeUpload" :multiple="multiple" :on-exceed="handleExceed" :on-remove="handleRemove"
      :on-error="handleUploadError" name="file" :show-file-list="false" :data="data" :limit="limit"
      :on-preview="handlePictureCardPreview" :on-progress="uploadProcess"
      :class="{ hide: this.fileList.length >= this.limit }" :headers="headers" :disabled="loading" drag>
      <!-- <el-button size="small" type="primary">点击上传</el-button> -->
	  <el-button class="btn-primary w-24 " round type="primary" size="default" :loading="loading">Upload</el-button>
    </el-upload>
    <!-- <div v-for="(item, index) in value" :key="index">
      {{ item }}
      <el-button size="small" type="danger" @click="Del(index)">删除</el-button>
    </div> -->
    <div>
      <div style="display: flex;flex-wrap: wrap;">
        <div v-for="(item, index) in value" :key="item.url" style="display: flex;flex-direction: column;margin-right: 20px;margin-bottom: 10px;" v-if="isImageUrl(item.url)">
        	<el-image v-if="isImageUrl(item.url)" style="width: 100px; height: 100px;" :src="item.url" :preview-src-list="[item.url]"></el-image>
        	<el-button size="mini" type="danger" @click="Del(index)">delete</el-button>
        </div>
      </div>
      <div>
        <div v-for="(item, index) in value" :key="item.url" style="display: flex;align-items: center;" v-if="!isImageUrl(item.url)">
        	<div style="width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color: #1890ff;cursor: pointer;margin-bottom: 10px;width: 50%;" @click="onPreview(item)">
            {{ item.name }}
          </div>
        	<el-button style="margin-left: 20px;" size="mini" type="danger" @click="Del(index)">delete</el-button>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" title="Preview" width="800" append-to-body :close-on-click-modal="false">
      <img :src="dialogImageUrl" style="display: block; max-width: 100%; margin: 0 auto" />
    </el-dialog>
  </div>
</template>

<script>

export default {
  props: {
    value: [String,Array],
    // 图片数量限制
    limit: {
      type: Number,
      default: 1,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    fileType: {
      type: Array,
      default: () => ['doc', 'xls', 'ppt', 'txt', 'pdf', 'json']
    },
    column: [String],
    // 上传地址
    uploadUrl: {
      type: String,
      default: process.env.VUE_APP_UPLOAD_URL,
    },
    // 大小限制(MB)
    fileSize: {
      type: Number,
      default: 5,
    },
    // 显示手动输入地址
    showInput: false,
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: true,
    },
    // 上传携带的参数
    data: {
      type: Object,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      hideUpload: false,
      uploadImgUrl: process.env.VUE_APP_BASE_API + this.uploadUrl, // 上传的图片服务器地址
      // headers: {
      //   Authorization: 'Bearer ' + getToken(),
      // },
      imageUrl: '',
      fileList: [],
	  loading: false
    }
  },
  computed: {
    headers() {
      const token = this.$store.getters.token
  
      return {
        Authorization: (token.tokenHead && token.tokenHead.length > 0 ? token.tokenHead : 'Bearer') +
        ' ' +
        (token.accessToken ? token.accessToken : '')
      }
    }
  },
  watch: {
    // // 监听 v-model 的值
    // value: {
    //   immediate: true,
    //   deep: true,
    //   handler: function (val) {
    //     if (val) {
    //       // 首先将值转为数组
    //       const list = Array.isArray(val) ? val : this.value.split(',')
    //       // 然后将数组转为对象数组
    //       this.fileList = list.map((item) => {
    //         console.log(item);
    //         if (typeof item === 'string') {
    //           // if (item.indexOf(this.baseUrl) === -1) {
    //           //     item = { name: this.baseUrl + item, url: this.baseUrl + item };
    //           // } else {
    //           item = { name: item, url: item }
    //           // }
    //         }
    //         return item
    //       })
    //     } else {
    //       this.fileList = []
    //       return []
    //     }
    //   },
    // },
  },
  methods: {
    isImageUrl(url) {
    	const filename = url.split('/').pop();
    	const extension = filename.split('.').pop().toLowerCase();
    	const imageExtensions = ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'svg'];
    	return imageExtensions.includes(extension);
    },
    Del(index) {
      this.value.splice(index, 1)
      this.$emit('input', this.value)
    },
    // 删除图片
    handleRemove(file, fileList) {
      console.log(fileList);
      // const findex = this.fileList.map((f) => f.name).indexOf(file.name)
      // if (findex > -1) {
      //   this.fileList.splice(findex, 1)
      //   this.$emit('input', this.column, this.listToString(this.fileList), '', fileList)
      // }
    },
    // 上传成功回调
    handleUploadSuccess(res, file, fileList) {
		this.loading = false
      if (res.code != 200) {
		  this.$notify.error('upload fail')
        return
      }
      if (fileList.every((item) => item.status == 'success')) {
        // fileList.map((item) => {
        //   /** 这时只需要push进带有response的数据就好 */
        //   if (item.response) {
        //     this.fileList.push({
        //       name: item.response.data.fileName,
        //       url: item.response.data.url
        //     })
        //   }
        // })
        // this.$emit(`input`, this.column, this.listToString(this.fileList), this.fileList, fileList)
        this.$emit('input', fileList.map((item) => {
          return {
            name: item.name,
            url: item.url || item.response.data.url
          }
        }))
      }
      // this.fileList.push({ name: res.data.fileName, url: res.data.url })
    },
    // 上传前loading加载
    handleBeforeUpload(file) {
		if (this.loading) return
		this.loading = true
      // if (this.fileType && this.fileType.length > 0) {
      //   let fileExtension = ''
      //   if (file.name.lastIndexOf('.') > -1) {
      //     fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1)
      //   }
      //   const isTypeOk = this.fileType.some((type) => {
      //     if (file.type.indexOf(type) > -1) return true
      //     if (fileExtension && fileExtension.indexOf(type) > -1) return true
      //     return false
      //   })
      //   if (!isTypeOk) {
      //     this.msgError(
      //       `文件格式不正确, 请上传${this.fileType.join('/')}格式文件!`
      //     )
      //     return false
      //   }
      // }
      // if (this.fileSize) {
      //   const isLt = file.size / 1024 / 1024 < this.fileSize
      //   if (!isLt) {
      //     this.msgError(`上传头像图片大小不能超过 ${this.fileSize} MB!`)
      //     return false
      //   }
      // }
    },
    // 文件个数超出
    handleExceed() {
      // this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`)
	  this.$notify.error({ message: 'exceed the limit' })
    },
    // // 预览
    onPreview(e) {
    	window.open(e.url, "_blank")
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    // 对象转成指定字符串分隔
    listToString(list, separator) {
      let strs = ''
      separator = separator || ','
      for (const i in list) {
        strs += list[i].url.replace(this.baseUrl, '') + separator
      }
      return strs != '' ? strs.substr(0, strs.length - 1) : ''
    },
    handleUploadError() {
      this.$notify.error('upload fail')
    },
    // 上传进度
    uploadProcess(event, file, fileList) {
      // console.log('上传进度' + file.percentage)
    },
  },
}
</script>

<style scoped lang="scss">
	::v-deep .el-upload{
	  width: 100%;
	}
	::v-deep .el-upload .el-upload-dragger{
	  width: 100%;
	  height: 80px;
	  border: none;
	  text-align: left;
	}
::v-deep.hide .el-upload--picture-card {
  display: none;
}

// 去掉动画效果
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
  transition: all 0s;
}

::v-deep .el-list-enter,
.el-list-leave-active {
  opacity: 0;
  transform: translateY(0);
}

.is-readonly {
  ::v-deep .el-upload.el-upload--picture-card {
    display: none;
  }
}
</style>
